<cc-box>
  <div
    class="lg-container"
    box
    header>{{'LEAD_GENERATION.CREATOR.BUBBLE.BUBBLE_TYPE' | translate }}
  </div>
  <form
    [formGroup]="popupSettings"
    class="lg-container"
    box
    content>
    <mat-radio-group formControlName="closeButtonEnabled">
      <div class="radio-container">
        <img class="icon with_close">
        <mat-radio-button
          [value]="true">{{'LEAD_GENERATION.CREATOR.BUBBLE.WITH_CLOSE_ICON' | translate }}
        </mat-radio-button>
      </div>
      <div class="radio-container">
        <img class="icon without_close">
        <mat-radio-button
          [value]="false">{{'LEAD_GENERATION.CREATOR.BUBBLE.WITHOUT_CLOSE_ICON' | translate }}
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </form>
</cc-box>
